import { render, staticRenderFns } from "./NolaNovelData.vue?vue&type=template&id=1ede4c5e&scoped=true"
import script from "./NolaNovelData.vue?vue&type=script&lang=ts"
export * from "./NolaNovelData.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelData.vue?vue&type=style&index=0&id=1ede4c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede4c5e",
  null
  
)

export default component.exports